module.exports = __webpack_public_path__ + "img/454.40192320.jpg";